import apiFetch from '../apiFetch'

export default function (token, data) {
  return apiFetch({ endPoint: 'Fleets/FindFleetManager', method: 'POST', body: data, token: token })
}
